import { getMarketCodeFromCentraLocale } from "@/app/(site)/_utils/misc"
import { CENTRA_MARKET_CODE } from "@/data/supported-markets"
import { mapMarketCodeToMarketId } from "@/maps/map-utils"
import marketCodeToMarketIdMap, { MarketId } from "@/maps/market-code-to-market-id"

export const mapCentraLocaleToMarketCodeThenToMarketId = (centraLocale: string) => {
    const marketCode = getMarketCodeFromCentraLocale(centraLocale)
    const marketId = mapMarketCodeToMarketId(marketCode)
    return marketId || (marketCodeToMarketIdMap.get(CENTRA_MARKET_CODE.Eu) as MarketId) //as MarketId because .get() *can* return undefined
}
